/**
 * The consultant's daily limits in words (the Consultant usage tab of Settings): the limits, the person's own count
 * and the org's, and who sets them. Pure.
 */
import { isConsultantOff, type CopilotMemberLimits } from "@/lib/api/copilot-limits";
import { formatStamp } from "@/lib/plant-days";

/** What the tab shows: the limits, a read on its way, no consultant, a failed read, or a demo that reads no limits. */
export type ConsultantLimitsState = "ready" | "loading" | "off" | "error" | "not_live";

/** The tab's state from the read: outside the live platform the read never runs, so it says so rather than wait. */
export function consultantLimitsState(read: { live: boolean; data?: unknown; error?: unknown }): ConsultantLimitsState {
  if (!read.live) return "not_live";
  if (read.data) return "ready";
  if (read.error) return isConsultantOff(read.error) ? "off" : "error";
  return "loading";
}

const count = (n: number) => n.toLocaleString("en-US");

export function consultantLimitsLines(l: CopilotMemberLimits, orgName: string): string[] {
  return [
    `Each person may send the AI casting consultant ${count(l.user_daily)} messages in any 24 hours, and ${orgName} ${count(
      l.org_daily,
    )} in all.`,
    `You have sent ${count(l.own_count)} since ${formatStamp(l.own_since)}; ${orgName} has sent ${count(
      l.org_count,
    )} since ${formatStamp(l.org_since)}.`,
    l.org_set
      ? `Sahas set these limits for ${orgName}. Ask your Sahas contact to change them.`
      : "These are the platform's limits. Ask your Sahas contact if your plant needs more.",
  ];
}
